module.exports = __webpack_public_path__ + "img/structural.1489ca74.jpg";